import {
  AutorizacionComisionMockUp,
  ResumenAutorizacionMockUp
} from "./AutorizacionComisiones.types";

export const mockResumen: ResumenAutorizacionMockUp = {
  ventas: 196,
  ventasRechazadas: 5,
  anualidades: 68,
  anualidadesRechazadas: 4,
  asesores: 17,
  asesoresContactCenter: 9,
  montoTotal: 248000.0,
  autorizado: false
};

export const mockData: AutorizacionComisionMockUp[] = [
  {
    membresia: "Obrero Mundial 1517",
    tipoMembresia: "Oro",
    tipoComision: "Reactivación (Asesor)",
    alcance: "89%",
    monto: 200,
    empleado: "Maribel Estrada",
    seleccionado: false
  },
  {
    membresia: "Obrero Mundial 1518",
    tipoMembresia: "Plata",
    tipoComision: "Venta (Asesor)",
    alcance: "108%",
    monto: 300,
    empleado: "Antonio Gonzalez",
    seleccionado: false
  },
  {
    membresia: "Obrero Mundial 1318",
    tipoMembresia: "Plata",
    tipoComision: "Venta (Líder Comercial)",
    alcance: "97%",
    monto: 80,
    empleado: "Arturo Salgado",
    seleccionado: false
  }
];
